import React, { FC } from 'react';
import styled, { css } from 'styled-components';

interface ArrowProps {
    direction?: 'up' | 'down' | 'left' | 'right';
}

const StyledArrow = styled.svg<ArrowProps>`
    ${({ direction }) => css`
        transition: transform 0.2s ease;
        ${direction === 'up' &&
        css`
            transform: rotate(90deg);
        `}
        ${direction === 'right' &&
        css`
            transform: rotate(180deg);
        `}
  ${direction === 'down' &&
        css`
            transform: rotate(270deg);
        `}
    `}
`;

const Arrow: FC<ArrowProps> = ({ direction = 'left' }) => (
    <StyledArrow
        direction={direction}
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <title>Icon - Arrow</title>
        <g id="Icon---Arrow" stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
            <rect id="Rectangle" x={0} y={0} width={24} height={24} />
            <path
                d="M7.3826087,11.1552795 L14.1403727,4.39751553 C14.6074534,3.93043478 15.3627329,3.93043478 15.8248447,4.39751553 L16.9478261,5.52049689 C17.4149068,5.98757764 17.4149068,6.74285714 16.9478261,7.20496894 L12.1627329,12 L16.952795,16.7900621 C17.4198758,17.2571429 17.4198758,18.0124224 16.952795,18.4745342 L15.8298137,19.6024845 C15.3627329,20.0695652 14.6074534,20.0695652 14.1453416,19.6024845 L7.38757764,12.8447205 C6.91552795,12.3776398 6.91552795,11.6223602 7.3826087,11.1552795 Z"
                id="Path"
                fill="currentColor"
            />
        </g>
    </StyledArrow>
);

export default Arrow;
